<template>
  <div :id="'sendMessage'+formScope">
    <!--<form novalidate id="form-send-message" class='hex-form' action="/manusersendmsg/userpage/" method="post">-->
    <form @submit.prevent="validateBeforeSubmit(formScope)" :data-vv-scope="formScope">
      <div class="padding-70">
        <slot></slot>

        <div v-if="name" class="form-group mb-9">
          <!-- <label v-show="labeled" for="name" class="label required"></label> -->
          <!-- <input
            id="name"
            name="name"
            class="form-control standart-input"
            :data-vv-as="$t('Имя')"
            v-model="input.name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('name', formScope) }"
            type="text"
            :placeholder="$t('Имя')"
          > -->
          <!-- TODO: ВАЛИДАЦИЯ!! -->
          <v-input name="name" type="text" validate="required">Имя</v-input>
          <!-- <p
            v-show="errors.has('name', formScope)"
            class="alert-danger"
          >{{ errors.first('name', formScope) }}</p>-->
        </div>

        <div v-if="email" class="form-group mb-9">
          <!-- <label v-show="labeled" for="emailf" class="label required"></label> -->
          <input
            id="emailf"
            name="email"
            class="form-control standart-input"
            data-vv-as="email"
            v-model="input.email"
            v-validate="'required|email'"
            :class="{'input': true, 'is-danger': errors.has('email', formScope) }"
            type="text"
            placeholder="E-mail"
          >
          <!-- <p
            v-show="errors.has('email', formScope)"
            class="alert-danger"
          >{{ errors.first('email', formScope) }}</p>-->
        </div>

        <div v-if="phone" class="form-group mb-9">
          <!-- <label v-show="labeled" for="phone" class="label required"></label> -->
          <!-- <input
            id="phone"
            name="phone"
            class="form-control standart-input"
            :data-vv-as="$t('Телефон')"
            v-model="input.phone"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('phone', formScope) }"
            type="tel"
            :placeholder="$t('Телефон')"
          > -->
          <v-input name="phone" type="tel" validate="required">Телефон</v-input>
          <!-- <p
            v-show="errors.has('phone', formScope)"
            class="alert-danger"
          >{{ errors.first('phone', formScope) }}</p>-->
        </div>

        <div v-if="messages" class="form-group mb-9">
          <!-- <label class="send_message" for="send_message">{{$t('Отправить сообщение')}}</label> -->
          <textarea
            id="send_message"
            v-validate="'required'"
            v-model="input.textmessage"
            :placeholder="$t('Сообщение')"
            name="message"
            class="form-control input-lg"
            cols="5"
            rows="4"
          ></textarea>
          <!-- <i v-show="errors.has('message', formScope)" class="fa fa-warning"></i>
          <span
            v-show="errors.has('message', formScope)"
            class="help is-danger"
          >{{ errors.first('message', formScope) }}</span>-->
        </div>

        <vue-recaptcha
          ref="recaptcha"
          @verify="onVerify"
          @expired="onExpired"
          sitekey="6LdDEV4UAAAAAHSjYO_0h0EPHA2YAXVmfJvv6OkW"
        ></vue-recaptcha>
        <div class="m-11">
          <!-- <button class="btn-un-form" type="submit">{{$t('Отправить сообщение')}}</button> -->
          <v-btn color="green" big type="submit" class="d-block mx-auto">{{$t('Отправить')}}</v-btn>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Noty from "noty";
export default {
  name: "sendMessages",
  props: {
    formname: {
      type: String,
      default: ""
    },
    // formlabel: {
    //   type: String,
    //   default: ""
    // },
    urls: {
      type: [Number, String],
      default: ""
    },
    labeled: Boolean,
    phone: Boolean,
    name: Boolean,
    messages: Boolean,
    email: Boolean
  },
  props: {
    user_info: Object,
  },
  mounted() {
    if (this.formname !== "") {
      this.formScope = this.formname;
    }
  },
  data() {
    return {
      input: {
        textmessage: "",
        message: "",
        email: "",
        phone: "",
        name: ""
      },
      formScope: "",
      onCaptchaVerified: "",
      onCaptchaExpired: ""
    };
  },
  methods: {
    onVerify: function(response) {
      this.onCaptchaVerified = response;
      // console.log('Verify: ' + response)
    },
    onExpired: function() {
      this.onCaptchaExpired = "Expired";
      // console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    validateBeforeSubmit(scope) {
      // this.$refs.invisibleRecaptcha.execute()
      // console.log('work');
      this.$validator
        .validateAll(scope)
        .then(result => {
          if (result) {
            const data = new FormData();
            if (!_.isEmpty(this.input.textmessage)) {
              data.append("textmessage", this.input.textmessage);
            }
            if (!_.isEmpty(this.input.email)) {
              data.append("email", this.input.email);
            }
            if (!_.isEmpty(this.input.phone)) {
              data.append("phone", this.input.phone);
            }
            if (!_.isEmpty(this.input.name)) {
              data.append("name", this.input.name);
            }
            if (!_.isEmpty(this.onCaptchaVerified)) {
              data.append("gse", this.onCaptchaVerified);
            }
            $("html").removeClass("html-overflow");
            $(".modal").removeClass("open");
            $(".modal-overflow").removeClass("open");
            axios
              .post(this.urls, data)
              .then(response => {
                // console.log(response);
                if (response.data.success === true) {
                    if(localStorage.getItem('dev_mode')){
                    }else {
                        try {
                            ym(40131035, "reachGoal", "SEND_FORM");
                            ym(40131035, 'userParams', {
                                manufacturer: true,
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        try {
                            dataLayer.push({
                                event: "EVENT2GA",
                                eventCategory: "SEND",
                                eventAction: "FORM",
                                eventLabel: "",
                                eventValue: ""
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        try {
                            fbq("trackCustom", "SEND_FORM");
                        } catch (e) {
                            console.log(e);
                        }
                    }
                  // location.reload();
                  new Noty({
                        type: response.data.alerts[0].type,
                        layout: "center",
                        theme: "sunset",
                        // text: response.data.alerts[0].text,
                        text: this.$t(
                            "Благодарим за обращение, мы свяжемся с вами в ближайшее время"
                        ),
                        timeout: 2000,
                        progressBar: true,
                        closeWith: ["click", "button"],
                        animation: {
                            open: "noty_effects_open",
                            close: "noty_effects_close"
                        }
                    }).show();
                  // this.loading = true;
                  // location.reload();
                } else if (response.data.success === false) {
                  new Noty({
                    type: response.data.alerts[0].type,
                    layout: "topLeft",
                    theme: "sunset",
                    text: response.data.alerts[0].text,
                    timeout: 2000,
                    progressBar: true,
                    closeWith: ["click", "button"],
                    animation: {
                      open: "noty_effects_open",
                      close: "noty_effects_close"
                    }
                  }).show();
                  window.history.back();
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          } else {
            var n = new Noty({
              type: "warning",
              layout: "topLeft",
              theme: "sunset",
              text: "Ошибка",
              timeout: 2000,
              progressBar: true,
              closeWith: ["click", "button"],
              animation: {
                open: "noty_effects_open",
                close: "noty_effects_close"
              }
            }).show();
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss">
</style>
